export enum WIDGET_IFRAME_KEYS {
    /**
     * @value Disable scroll
     */
    DISABLE_SCROLL = 'WIDGET_TYPE_IFRAME_DISABLE_SCROLL',
    /**
     * @value Display borders
     */
    DISPLAY_BORDER = 'WIDGET_TYPE_IFRAME_DISPLAY_BORDERS',
    /**
     * @value Iframe
     * @description Iframe source for search settings
     */
    IFRAME = 'SEARCH_SETTINGS.IFRAME_SOURCE_TITLE',
    /**
     * @value Height
     */
    IFRAME_SETTINGS_HEIGHT = 'WIDGET_TYPE_IFRAME_SETTINGS_HEIGHT',
    /**
     * @value Width
     */
    IFRAME_SETTINGS_WIDTH = 'WIDGET_TYPE_IFRAME_SETTINGS_WIDTH',
    /**
     * @value Iframe options
     * @description Display the title of the widget iframe settings dialogue with all the configuration options available for this specific widget.
     */
    IFRAME_WIDGET_SETTINGS_TITLE = 'DESIGNER.IFRAME_WIDGET_SETTINGS_TITLE',
    /**
     * @value Display the "Open in new tab" button
     * @description Display a label for the widget settings checkbox that enable the "open in a new tab" feature
     */
    OPEN_IN_NEW_TAB_LABEL = 'WIDGET_IFRAME_SETTINGS.OPEN_IN_NEW_TAB_LABEL',
    /**
     * @value Send content id
     */
    SEND_CONTENT_ID = 'FRONT.IFRAME.CONTENT_ID_NAME',
    /**
     * @value Allow to identify the current content id within the iframe url.
     */
    SEND_CONTENT_ID_HELPER = 'FRONT.IFRAME.CONTENT_ID_HELP',
    /**
     * @value Send user identity
     */
    SEND_USER_IDENTITY = 'FRONT.IFRAME.USER_IDENTITY_NAME',
    /**
     * @value Allow to identify the current user within the iframe url.
     */
    SEND_USER_IDENTITY_HELPER = 'FRONT.IFRAME.USER_IDENTITY_HELP',
    /**
     * @value Use a custom URL
     * @description Display a label in front of a radio button option, in order to chose a custom URL
     */
    USE_CUSTOM_URL_LABEL = 'WIDGET_IFRAME_SETTINGS.USE_CUSTOM_URL_LABEL',
    /**
     * @value Use the iframe URL
     * @description Display a label in front of a radio button option, in order to choose what URL use
     */
    USE_IFRAME_URL_LABEL = 'WIDGET_IFRAME_SETTINGS.USE_IFRAME_URL_LABEL',
    /**
     * @value No iframe yet
     * @description Empty state title when the widget settings has not been filled yet
     */
    WRITER_MODE_EMPTY_STATE_TITLE = 'WIDGET_IFRAME_SETTINGS.NO_IFRAME_TITLE',
}
